import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const boxStyle = {
  padding: 12, borderRadius: 8, border: '2px solid #db2777',
  background: 'var(--card)', minWidth: 220, fontSize: 13, color: 'var(--text)',
};
const selStyle = {
  width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)',
  color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4,
};

export default function LiquiditySweepNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };
  const dir = data.direction || 'bearish';
  return (
    <div style={boxStyle}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#f472b6' }}>💧 Liquidity Sweep</div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select value={dir} onChange={(e) => onChange('direction', e.target.value)} style={selStyle}>
        <option value="bearish">Bearish (sweep highs → reverse down)</option>
        <option value="bullish">Bullish (sweep lows → reverse up)</option>
      </select>

      <div style={{ marginTop: 2, fontSize: 10, color: 'var(--muted)' }}>
        Stop-hunt: fires (1) when a wick pierces the last {dir === 'bearish' ? 'swing high' : 'swing low'} then
        closes back inside. Compare with value 1.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#db2777' }} />
    </div>
  );
}
